import { ApiValidateEmailAddressRequest } from '../interfaces/api.validate-email-address.request';

export function mapValidateEmailAddressRequest(code: string): ApiValidateEmailAddressRequest {
    return {
        controle_code: code,
    };
}
